import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  ArrowBack as ArrowLeft,
  CalendarToday as Calendar,
  Person as User,
  Email as Mail,
  BusinessCenter,
} from "@mui/icons-material";

import { getMailById } from "../../../redux/actions/authActions";

const MailDetails = () => {
  const { mailId } = useParams();
  console.log("Route mailId:", mailId); // ✅ FIXED
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const mail = useSelector((state) => state.auth.mail);
    console.log("Redux mail:", mail);

  useEffect(() => {
    if (mailId) {
      dispatch(getMailById(mailId));
    }
  }, [dispatch, mailId]);

  if (!mail) {
    return <div className="p-10 text-center">Loading mail details...</div>;
  }

  const client = mail.to || {};

  return (
    <div className="p-6 max-w-5xl mx-auto">
      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        className="flex items-center text-gray-600 hover:text-blue-600 mb-6"
      >
        <ArrowLeft fontSize="small" />
        <span className="ml-1 font-medium">Back to Mails</span>
      </button>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Left Side */}
        <div className="lg:col-span-2 space-y-6">
          <div className="bg-white rounded-xl shadow-sm border p-6">
            <h1 className="text-2xl font-bold mb-2">{mail.subject}</h1>

            <div className="flex items-center text-sm text-gray-500 mb-6">
              <Calendar sx={{ fontSize: 18 }} className="mr-2" />
              Sent on: {new Date(mail.createdAt).toLocaleString()}
            </div>

            <hr className="mb-6" />

            <div
              className="mail-content-preview border p-4 rounded-lg bg-gray-50"
              dangerouslySetInnerHTML={{ __html: mail.html }}
            />
          </div>
        </div>

        {/* Right Side */}
        <div className="space-y-6">
          <div className="bg-white rounded-xl shadow-sm border p-6">
            <h3 className="text-lg font-semibold mb-4 flex items-center">
              <User className="mr-2 text-blue-500" />
              Recipient Details
            </h3>

            <div className="space-y-4">
              <div>
                <label className="text-xs font-bold text-gray-400 uppercase">
                  Name
                </label>
                <p className="font-medium">
                  {client.name || mail.name || "N/A"}
                </p>
              </div>

              <div>
                <label className="text-xs font-bold text-gray-400 uppercase">
                  Email Address
                </label>
                <p className="flex items-center">
                  <Mail sx={{ fontSize: 16 }} className="mr-2 text-gray-400" />
                  {mail.emailAddress}
                </p>
              </div>

              <div>
                <label className="text-xs font-bold text-gray-400 uppercase">
                  Business
                </label>
                <p className="flex items-center">
                  <BusinessCenter
                    sx={{ fontSize: 16 }}
                    className="mr-2 text-gray-400"
                  />
                  {client.businessName || "N/A"}
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MailDetails;
